import type { EnvironmentDto } from '@onereach/billing-dto';

export function hasEnvironmentService(environment: EnvironmentDto | undefined, serviceKey: string): boolean {
  const services: unknown = environment?.discoveryData?.services;
  return Array.isArray(services) && services.some((service: unknown) =>
    typeof service === 'object' && service !== null && 'serviceKey' in service && service.serviceKey === serviceKey);
}
